<template>
  <JContainer>
    <TheMobileHeader
      :title="$t('trips.title')"
      titleClass="font-bold text-base"
      showBack
      @back="returnPreviousRoute"
    />

    <JBreadcrumb
      v-if="isDesktop"
      class="pb-16 pt-40"
      :items="[
        { label: $t('words.home'), url: '/' },
        { label: $t('trips.myTrips') },
      ]"
    />

    <ReviewTrips />
  </JContainer>
</template>

<script setup lang="ts">
import { useHead } from '@unhead/vue'
import { useI18n } from 'vue-i18n'
import { JBreadcrumb, JContainer } from '@journey/ui-kit'
import { useRouter } from 'vue-router'
import ReviewTrips from '../components/ReviewTrips/ReviewTrips.vue'
import useHelpStore from '@/modules/Help/store'
import TheMobileHeader from '@/modules/Core/components/layout/MobileHeader/TheMobileHeader.vue'
import { HELP_SECTIONS } from '@/modules/Core/constants'
import { useDevicePlatform } from '@/modules/Core/composables'

const { t } = useI18n()

useHead({
  titleTemplate: (title) => `${title} - ${t('trips.title')}`,
})

// RECENT ACTIVITY
const helpStore = useHelpStore()

helpStore.setRecentActivity(HELP_SECTIONS.Trips)

// RETURN PREVIOUS ROUTE
const router = useRouter()

const { isDesktop } = useDevicePlatform()

function returnPreviousRoute() {
  const url = router.options.history.state.back as string
  const regex = /\/trips\/([A-Z0-9]+)/
  const match = url.match(regex)

  if (match && match[1]) {
    router.push({ name: 'Search' })
    return
  }

  router.go(-1)
}
</script>
